export type MediaKind = 'image' | 'video' | 'document' | 'file';

export interface MediaPreviewItem {
	kind?: MediaKind | string | null;
	mime?: string | null;
	extension?: string | null;
	name?: string | null;
	thumbnail?: string | null;
	webp?: string | null;
	original?: string | null;
}

// Only for the items that carry no "kind" from the server (the image saved in the content of a page has just its URLs).
// The items of the media library come with the kind that the server worked out from the stored MIME type.
const KIND_BY_EXTENSION: Record<string, MediaKind> = {
	jpg: 'image', jpeg: 'image', png: 'image', gif: 'image', webp: 'image', avif: 'image', svg: 'image', ico: 'image',
	mp4: 'video', webm: 'video', mpeg: 'video', avi: 'video',
	pdf: 'document',
};

export const extensionOf = (url: string | null | undefined): string => {
	const path = (url ?? '').split(/[?#]/)[0];
	const dot = path.lastIndexOf('.');

	return dot > path.lastIndexOf('/') ? path.slice(dot + 1).toLowerCase() : '';
};

export const mediaKind = (item: MediaPreviewItem): MediaKind => {
	if (item.kind === 'image' || item.kind === 'video' || item.kind === 'document' || item.kind === 'file') {
		return item.kind;
	}

	const mime = (item.mime ?? '').toLowerCase();
	if (mime.startsWith('image/')) {
		return 'image';
	}
	if (mime.startsWith('video/')) {
		return 'video';
	}
	if (mime === 'application/pdf') {
		return 'document';
	}

	return KIND_BY_EXTENSION[(item.extension ?? extensionOf(item.original)).toLowerCase()] ?? 'file';
};
